/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Selected_Job_Ads_TitleInputs */

const en_selected_job_ads_title = /** @type {(inputs: Selected_Job_Ads_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selected job postings`)
};

const de_selected_job_ads_title = /** @type {(inputs: Selected_Job_Ads_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausgewählte Stellenanzeigen`)
};

/**
* | output |
* | --- |
* | "Selected job postings" |
*
* @param {Selected_Job_Ads_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const selected_job_ads_title = /** @type {((inputs?: Selected_Job_Ads_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Selected_Job_Ads_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_selected_job_ads_title(inputs)
	return en_selected_job_ads_title(inputs)
});